import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CityResponse } from '../../shared/models/city.model';
import { CityService } from '../../shared/services/city.service';

@Injectable({
  providedIn: 'root',
})
export class GetCitiesResolver implements Resolve<CityResponse[]> {
  constructor(private cityService: CityService) {}

  resolve(): Observable<CityResponse[]> {
    return this.cityService.getAll();
  }
}
